/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'va': {
    width: 308,
    height: 216.4,
    viewBox: '0 0 308 216.4',
    data: '<path pid="0" d="M307.9 39c-21.7 50.1-57.8 58.3-91.4 62.3L178.5 0h-19.4L90.7 183.4 21.7 0H.1l78.3 216.2-.1.2H110.7s7.3-19.8 14.6-39.8c8.6-23.5 29.9-52 70.8-57.6 1.1-.2 2.3-.3 3.4-.4l35.4 97.9h24.6l-37.8-100.9c31.3-5.1 60.4-16.8 86.2-76.6m-117 65.2c-20.9 2.9-38.7 5.2-54.8 19.9l32.7-90.9 25.5 70.6c-1.2.1-2.3.3-3.4.4"/>'
  }
})
